module.exports = __webpack_public_path__ + "static/media/card3_7.99f016d0.png";